module.exports = __webpack_public_path__ + "static/media/kaylo-logo.04314fdd.svg";